module.exports = __webpack_public_path__ + "static/media/Preview.8b6550d6.png";